/**
 * Rocnovel 品牌 - Welfare 页面配置
 */
import { welfareCommonConfig } from './common'
import type { WelfarePageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

/**
 * Rocnovel 品牌特定主题配置
 */
export const theme = {
  // 按钮背景色 (Oceread 使用 #F6F4FB)
  btnBg: '#F6F4FB',
  // 按钮文本颜色 (Oceread 使用主色)
  btnText: brandTheme.primaryColor,
  // 金币颜色 (Oceread 使用主色)
  coinsColor: brandTheme.primaryColor,
} as const

/**
 * Rocnovel 品牌特定资源配置
 */
export const resources = {
  // 首页背景图
  homeBg: '/images/rocnovel/home-bg.webp',
  // 金币图标
  welfareGold: '/images/rocnovel/welfare-gold.png',
  // 宝箱图标
  welfareBox: '/images/rocnovel/welfare-box.png',
} as const

export const welfareConfig: WelfarePageConfig = {
  theme,
  resources,
  texts: welfareCommonConfig.texts,
}
